import React from 'react'
import { Paragraph } from '@scentregroup/ui'

import style from './index.module.scss'

interface IResultCounterProps {
  start: number
  end: number
  totalProducts: number
}

const RESULT_LIMIT = 10000

export const ResultCounter: React.FunctionComponent<
  React.PropsWithChildren<IResultCounterProps>
> = ({ start, end, totalProducts }) => {
  let message = 'No results'

  if (totalProducts === 1) {
    message = `${start}-${end} of ${totalProducts} result`
  }
  if (totalProducts > 1) {
    message = `${start}-${end} of ${totalProducts} results`
  }
  if (totalProducts == RESULT_LIMIT) {
    message = `${start}-${end} of over ${RESULT_LIMIT} results`
  }

  return (
    <Paragraph type="small" className={style.resultsCounter}>
      {message}
    </Paragraph>
  )
}
